import { NavigationProposals } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { BudgetPositionsPage } from "@src/components/modules/budgets/positions";
import { FullScreenContainer } from "@src/components/ui-kit";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => {
  return (
    <MainLayout title={t`Budgets`} navigation={<NavigationProposals />}>
      <FullScreenContainer>
        <BudgetPositionsPage />
      </FullScreenContainer>
    </MainLayout>
  );
};

export const Route = createFileRoute("/budgets/positions")({
  component: Page,
});
